import React from 'react';
import { useAppContext } from '../context/AppContext';
import { Bell, Mail, Phone, Shield, Activity } from 'lucide-react';
import { getRoleText } from '../utils/helpers';
import { t } from '../i18n';

const Profile = () => {
  const { currentUser, notifications, auditTrail } = useAppContext();

  const userNotifications = notifications.filter(
    (notification) => !notification.read
  );

  const lastActions = auditTrail
    .filter((entry) => entry.userId === currentUser?.id)
    .slice(0, 5);

  return (
    <div className="space-y-6">
      <div className="bg-white border border-neutral-200 rounded p-6">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6">
          <div className="flex items-center gap-4">
            <div className="w-16 h-16 rounded-full bg-neutral-700 flex items-center justify-center text-xl font-semibold text-neutral-100">
              {t(currentUser?.avatar)}
            </div>
            <div>
              <h1 className="text-xl font-semibold text-neutral-900">{t(currentUser?.name)}</h1>
              <p className="text-sm text-neutral-500">{t(getRoleText(currentUser?.role))}</p>
              <p className="text-xs text-neutral-400">{t('Último acceso:')} {t(currentUser?.lastLogin)}</p>
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 w-full md:w-auto">
            <div className="bg-neutral-50 border border-neutral-200 rounded p-3 text-sm">
              <div className="flex items-center gap-2 text-neutral-500">
                <Mail className="w-4 h-4" />{t('Correo')}</div>
              <p className="mt-2 text-neutral-900 font-medium">{t(currentUser?.email)}</p>
            </div>
            <div className="bg-neutral-50 border border-neutral-200 rounded p-3 text-sm">
              <div className="flex items-center gap-2 text-neutral-500">
                <Phone className="w-4 h-4" />{t('Teléfono')}</div>
              <p className="mt-2 text-neutral-900 font-medium">{t(currentUser?.phone) || t('Sin registrar')}</p>
            </div>
            <div className="bg-neutral-50 border border-neutral-200 rounded p-3 text-sm">
              <div className="flex items-center gap-2 text-neutral-500">
                <Shield className="w-4 h-4" />{t('Departamento')}</div>
              <p className="mt-2 text-neutral-900 font-medium">{t(currentUser?.department) || t('Sin asignar')}</p>
            </div>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 xl:grid-cols-2 gap-6">
        <div className="bg-white border border-neutral-200 rounded p-4">
          <div className="flex items-center gap-2 mb-3">
            <Bell className="w-4 h-4 text-neutral-500" />
            <h2 className="text-sm font-semibold text-neutral-900">{t('Notificaciones pendientes')}</h2>
          </div>
          <div className="space-y-2">
            {userNotifications.length === 0 && (
              <p className="text-sm text-neutral-400">{t('No tienes notificaciones pendientes.')}</p>
            )}
            {userNotifications.map((notification) => (
              <div
                key={notification.id}
                className="border border-neutral-200 rounded px-3 py-2 bg-neutral-50"
              >
                <p className="text-sm font-medium text-neutral-800">{t(notification.title)}</p>
                <p className="text-xs text-neutral-500">{t(notification.message)}</p>
                <p className="text-xs text-neutral-400 mt-1">{t(notification.createdAt)}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="bg-white border border-neutral-200 rounded p-4">
          <div className="flex items-center gap-2 mb-3">
            <Activity className="w-4 h-4 text-neutral-500" />
            <h2 className="text-sm font-semibold text-neutral-900">{t('Últimas acciones registradas')}</h2>
          </div>
          <div className="space-y-2">
            {lastActions.length === 0 && (
              <p className="text-sm text-neutral-400">{t('No hay movimientos registrados para tu usuario.')}</p>
            )}
            {lastActions.map((entry) => (
              <div
                key={entry.id}
                className="border border-neutral-200 rounded px-3 py-2 text-sm text-neutral-600"
              >
                <p className="font-medium text-neutral-800">{t(entry.action)}</p>
                <p className="text-xs text-neutral-400">{t(entry.entity)}</p>
                <p className="text-xs text-neutral-400">{t(entry.date)} · {t(entry.result)}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
